import { AbilityBuilder, Ability } from '@casl/ability'
import $store from '../store'

/** Set current user abilities. */
export default function defineAbilitiesFor() {
  const { can, rules } = new AbilityBuilder(Ability)

  if ($store.state.user.currentUser.id) {
    const userAbilities = $store.getters['user/abilities']

    Object.keys(userAbilities).forEach((key) => can(abilitiesHashes[userAbilities[key]], key))
  }

  can(abilitiesHashes.read, 'index')
  can(abilitiesHashes.read, 'auth')
  can(abilitiesHashes.read, 'account')
  can(abilitiesHashes.read, '404')

  return new Ability(rules)
}

const abilitiesHashes = {
  lock: ['nothing'],
  read: ['read'],
  edit: ['read', 'edit'],
}

const essenceKeys = ['applications', 'finances', 'logs', 'managers', 'payments']

/**
 * Uses if user or manager has `abilities` = `*`.
 *
 * @returns {Object} Abilities object with setted all abilities to `edit`.
 */
export const setSuperUserAbilities = () => {
  return essenceKeys.reduce(function (map, obj) {
    map[obj] = 'edit'
    return map
  }, {})
}

/**
 * Uses if backend answer 403 http code for request.
 *
 * @param {Object} error Server error object
 * @returns {} Refetch current user data. Then redirect user to '/nothfound' path.
 */
export function redirectIfDenied(error) {
  if (error && error.status !== 403) return

  this.$store.dispatch('user/getCurrent')
  this.$router.push({ path: '/notfound' })
}
